/**
 * The path the app is mounted on ("/homeschool" in production, "" if it is ever
 * served from a domain root). Vite fills `BASE_URL` from the `base` option in
 * vite.config.ts and always gives it a trailing slash.
 *
 * The Worker strips the same prefix before routing, so these two must agree.
 */
export const BASE_PATH = import.meta.env.BASE_URL.replace(/\/+$/, "");

/** Absolute in-app URL for a root-relative path, e.g. "/api/me". */
export function withBase(path: string) {
  return `${BASE_PATH}${path.startsWith("/") ? path : `/${path}`}`;
}
